import { Seo } from "@/components/Seo";
import GalleryPage from "@/pages/GalleryPage";

export default function ApparelPage() {
  return (
    <>
      <Seo
        title="Fitness & Cycling Apparel — Delta DL Enterprise, LLC"
        description="Delta DL Enterprise, LLC performance apparel — cycling jerseys, fitness tees, and hoodies built for riders and athletes. Request to purchase and we confirm your order personally."
        path="/apparel"
      />
      <GalleryPage
        only="apparel"
        overline="Fitness & Cycling"
        heading="Apparel"
        subtitle="Regular workout clothing of various types — tees, hoodies, leggings, tanks, and cycling gear, made for everyday training and riding."
        note="To order, tap 'Request to Purchase' on any item and we'll confirm size, color, and delivery personally by email. Questions about sizing welcome:"
      />
    </>
  );
}
